import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSeagateComponent } from './simple-icons-seagate.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSeagateComponent ],
    exports:      [ SimpleIconsSeagateComponent ],
    bootstrap:    []
})
export class SimpleIconsSeagateModule {}
